"use client";

import { useEffect } from "react";

export default function PlausibleAnalytics() {
  useEffect(() => {
    // Only run in browser
    if (typeof window === "undefined") return;

    // Dynamic import to avoid SSR issues
    import("@plausible-analytics/tracker").then(({ init }) => {
      init({
        domain: "township.agency",
        endpoint: "https://plausible.io/api/event",
        autoCapturePageviews: true,
        hashBasedRouting: false,
        outboundLinks: true,
        fileDownloads: true,
        formSubmissions: true,
        bindToWindow: true,
      });
    });
  }, []);

  return null;
}
